import { render, staticRenderFns } from "./ProviderCrudForm.vue?vue&type=template&id=d172158c&"
import script from "./ProviderCrudForm.vue?vue&type=script&lang=js&"
export * from "./ProviderCrudForm.vue?vue&type=script&lang=js&"
import style0 from "./ProviderCrudForm.vue?vue&type=style&index=0&id=d172158c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports